import type { ICard } from "../../cardsSlice";

export const major15Card: ICard = {
    id: "major_15",
    arcana: "major",
    number: 15,
    suit: "major",
    court: "major",
    name: "Дьявол",
    nameEn: "The Devil",
    keywords: ["Зависимость", "Иллюзии", "Привязанности"],
    symbolism: ["Демон с поднятой рукой", "Цепи на шеях людей", "Перевёрнутая пентаграмма, рога, хвосты"],
    symbolismInterpretation:
      "Символ подавления воли, материальных привязанностей и тёмных импульсов",
    archetype: "Тень психики, архетип искушения и несвободы",
    psychology: "Ощущение захваченности, страхи, неконтролируемые желания",
    upright: {
      personality: "Жадность, зависимость, подверженность соблазнам",
      relationships: "Токсическая связь, контроль, манипуляция",
      work: "Искушение властью или деньгами",
      spirituality: "Осознание теневых сторон, необходимость освобождения",
      examples: ["Привязанность к иллюзиям", "Контроль извне", "Потеря свободы"]
    },
    reversed: {
      meaning: "Освобождение, осознание ограничений",
      nuances: "Путь к внутреннему освобождению и признанию своей тени"
    },
    associations: ["Цепи", "Соблазн", "Тень", "Зависимость"],
    combinations: ["С Влюблёнными — разрушительная привязанность", "С Башней — резкое разрушение иллюзий"],
    readingTips: ["Выявить, что реально удерживает", "Признать свою долю ответственности"],
    selfQuestions: ["Что меня держит в оковах?", "Почему я боюсь отпустить ситуацию?"]
  };


